import React from 'react';
//components
import { Column, Row } from 'components/Layout/Grid';
import { TitleItemText, TitleItemSubtitle, TitleItemSubtitleRow, TitleItemValue, Container } from './styles';
//interfaces
import { ITitleList } from './interface';
//utils
import { DateOutputStr } from 'utils/DateOutput';
import { currencyOutputNumber } from 'utils/CurrencyOutput';

export const TitleList: React.FC<ITitleList> = (props) => {
  const {
    titleText,
    titleValue,
    issueDate,
    expirationDate,
    dayDelayNumber
  } = props;

  const issueDateToString = issueDate?.toString();
  const expirationDateToString = expirationDate?.toString();

  const dayDelayText = dayDelayNumber > 1 ? " dias" : " dia";

  return (
    <Container>
      <Row>
        <Column className='flex-5'>
          <TitleItemText size={16} color={'#0E4C54'}>Título {titleText}</TitleItemText>
        </Column>
        <Column>
          <TitleItemText size={16} color={'#E02828'}>{currencyOutputNumber(titleValue)}</TitleItemText>
        </Column>
      </Row>
      <TitleItemSubtitleRow className='mt-2'>
        <Column>
          <TitleItemSubtitle size={12} color={'#858585'}>Emissão</TitleItemSubtitle>
            <Row>
              <TitleItemValue size={14} color={'#0E4C54'}>{DateOutputStr(issueDateToString, 'dd/MM/yyyy')}</TitleItemValue>
            </Row>
        </Column>
        <Column>
          <TitleItemSubtitle size={12} color={'#858585'}>Vencimento</TitleItemSubtitle>
            <Row>
              <TitleItemValue size={14} color={'#0E4C54'}>{DateOutputStr(expirationDateToString, 'dd/MM/yyyy')}</TitleItemValue>
            </Row>
        </Column>
        <Column>
          <TitleItemSubtitle size={12} color={'#858585'}>Atraso</TitleItemSubtitle>
            <Row>
              <TitleItemValue size={14} color={'#0E4C54'}>{dayDelayNumber}{dayDelayText}</TitleItemValue>
            </Row>
        </Column>
      </TitleItemSubtitleRow>
    </Container>
  );
};